import types from "cms/enums/contentsTypes.enum";
export var infoBlockList = {
    label: "infos",
    type: types.INFO_BLOCK_LIST,
    dynamicChildKey: "infos"
};
